import { styled } from '@mui/material/styles';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { useNavigate } from 'react-router-dom';
import MenuContent from './MenuContent';

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
    width: drawerWidth,
    flexShrink: 0,
    boxSizing: 'border-box',
    mt: 10,
    [`& .${drawerClasses.paper}`]: {
        width: drawerWidth,
        boxSizing: 'border-box',
    },
});

export default function SideMenu() {
    const navigate = useNavigate();

    return (
        <Drawer
            variant="permanent"
            sx={{
                display: { xs: 'none', md: 'block' },
                [`& .${drawerClasses.paper}`]: {
                    backgroundColor: 'background.paper',
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    mt: 'calc(var(--template-frame-height, 0px) + 4px)',
                    p: 1.5,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Box
                    component="img"
                    src={`${process.env.PUBLIC_URL || ''}/images/logo.png`}
                    alt="Logo"
                    sx={{
                        maxWidth: '100%',
                        height: 'auto',
                        maxHeight: 56,
                        objectFit: 'contain',
                        cursor: 'pointer',
                        '&:hover': {
                            opacity: 0.8,
                        },
                    }}
                    onClick={() => navigate('/dashboard')}
                    onError={(e) => {
                        // Fallback if logo doesn't exist - show text instead
                        const parent = e.target.parentElement;
                        if (parent && !parent.querySelector('.logo-fallback')) {
                            e.target.style.display = 'none';
                            const fallback = document.createElement('div');
                            fallback.className = 'logo-fallback';
                            fallback.textContent = 'Admin';
                            fallback.style.cssText = 'font-size: 1.5rem; font-weight: bold; color: inherit; cursor: pointer; text-align: center; width: 100%;';
                            fallback.onclick = () => navigate('/dashboard');
                            parent.appendChild(fallback);
                        }
                    }}
                />
            </Box>
            <Divider />
            <Box
                sx={{
                    overflow: 'auto',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <MenuContent />
                {/* <CardAlert /> */}
            </Box>
        </Drawer>
    );
}
